<header>
  <nav class="navbar navbar-expand-lg navbar-toggleable-sm navbar-light bg-lightblue border-bottom box-shadow mb-3">
    <div class="container-fluid">
      <a class="navbar-brand" [routerLink]="['/']">BCF Credit Portal</a>
      <button class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target=".navbar-collapse"
              aria-label="Toggle navigation"
              [attr.aria-expanded]="isExpanded"
              (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse justify-content-center">
        <ul class="navbar-nav ml-auto mr-auto">
          <li class="p-2 nav-item">
            <a class="nav-link text-dark" [routerLink]="['/']">Home</a>
          </li>
          <li class="p-2 nav-item" *ngIf="canEditAccount">
            <a class="nav-link text-dark" [routerLink]="['/account-profile']">Account details</a>
          </li>
          <li class="p-2 nav-item" *ngIf="showOffsetPayments" [routerLinkActive]="'active'">
            <a class="nav-link text-dark" [routerLink]="['/quotes']">Offset Payments</a>
          </li>
          <li class="p-2 nav-item" [routerLinkActive]="'active'">
            <a class="nav-link text-dark" [routerLink]="['/wanted-credits']">Credit Offers</a>
          </li>
          <li *ngIf="enableOfferLink" class="p-2 nav-item" [routerLinkActive]="'active'">
            <a class="nav-link text-dark" [routerLink]="['/credit-offer']">Offer Application</a>
          </li>
         <li *ngIf="canEditAccount" class="p-2 nav-item"></li>
        </ul>
        <div *ngIf="canEditAccount" class="p-2 nav-item"><button class="btn btn-primary" (click)="logout()">Logout</button></div>
      </div>
    </div>
  </nav>
</header>
